import { useContext } from 'react'
import ActiveItemDivider from './ActiveItemDivider';
import { CraftIdentityContext } from 'pages/CraftIdentity';
import Cookies from 'js-cookie';

const ActiveItemIdentityCraftSelect = ({ item }) => {
  const { selectItemHandler, playSound } = useContext(CraftIdentityContext);

  const isBuyFromMarket = Cookies.get('isBuyFromMarket');

  const selectHandler = (item) => {
    playSound('craftSelectItem');
    selectItemHandler(item);
  }

  return <>
    <button className='card-details__combine-action card-details__combine-action--select' disabled={isBuyFromMarket} onClick={() => selectHandler(item)}>Select</button>
    <ActiveItemDivider />
  </>
}

export default ActiveItemIdentityCraftSelect;
